<template>
  <div class="bg-white mx-3 rounded-xl">
    <div class="flex justify-between">
      <div class="m-3 flex justify-between flex-col md:flex-row gap-3" style="width: 100%">
        <div class="flex gap-5 justify-between flex-col sm:flex-row w-full md:w-1/2">
          <div class="w-full">
            <input v-model="todoName" type="text" class="bg-gray-300 rounded-full p-2 px-3 w-full"
              placeholder="Search Todo" @change="filterByTodoName" />
          </div>

          <select class="bg-gray-300 rounded-full p-1.5 w-auto px-3" v-model="searchQuery">
            <option selected disabled value="">
              Filter by Urgency
            </option>
            <option v-for="urgency of urgencies" :key="urgency.id" class="cursor-pointer">
              {{ urgency }}
            </option>
          </select>


        </div>
        <Modal />
      </div>
    </div>
    <div class="overflow-x-auto md:overflow-x-hidden">
      <table class="table-auto text-xs sm:text-sm border-spacing-3" style="width: 100%">
        <thead class="text-left bg-gray-300 text-black">
          <tr>
            <th class="p-2">Todo</th>
            <th class="p-2">Issued By</th>
            <th class="p-2">Start Date</th>
            <th class="p-2">End Date</th>
            <th class="p-2">Status</th>
            <th class="p-2">Urgency</th>
            <th class="p-2">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="task of todosToShow" :key="task.id" class="border-b-1.5">
            <td class="p-2">{{ task.todoName }}</td>
            <td class="p-2">{{ task.issuedBy }}</td>
            <td class="p-2">{{ task.startDate }}</td>
            <td class="p-2">{{ task.endDate }}</td>
            <td class="p-2" :class="{
              'text-green-600': formatStatus(task.status),
              'text-yellow-600': formatStatus(task.status),
              'text-red-600': formatStatus(task.status),
            }">
              {{ task.status }}
            </td>
            <td class="p-2">
              {{ task.urgency }}
            </td>
            <td class="p-2">
              <div class="flex justify-center">
                <div>
                  <div class="dropdown relative">
                    <button
                      class="dropdown-toggle h-3 p-2 m-auto text-white font-medium text-xs leading-tight uppercase rounded focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg active:text-white transition duration-150 ease-in-out flex items-center whitespace-nowrap"
                      type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                      <img class="h-3" src="@/assets/icons/vertical-dots.png" />
                    </button>
                    <ul
                      class="dropdown-menu min-w-max absolute bg-white text-base z-50 float-left py-2 list-none text-left rounded-lg shadow-lg mt-1 hidden m-0 bg-clip-padding border-none border-1"
                      aria-labelledby="dropdownMenuButton1" style="width: 10vw">
                      <li>
                        <a class="dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:text-green-800"
                          href="#">Edit</a>
                      </li>
                      <li>
                        <a class="dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:text-green-600"
                          href="#">Details</a>
                      </li>
                      <li>
                        <a role="button"
                          class="dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:text-red-600"
                          href="#" @click="(event) => handleDelete(task)">Delete</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// import Multiselect from "vue-multiselect";
import Modal from "./Modal.vue";
export default {
  components: {
    Modal,
  },
  data() {
    return {
      searchQuery: "",
      todoName: null,
      todos: [
        {
          id: 1,
          todoName: "System X Maintainance",
          issuedBy: "Erickson Maxwell",
          startDate: "01/08/2022",
          endDate: "01/08/2022",
          status: "Ongoing",
          urgency: "Mild",
          action: ["edit", "delete"],
          actionIcon: "@/assets/icons/vertical-dots.png",
        },
        {
          id: 2,
          todoName: "System Y Design",
          issuedBy: "Erickson Maxwell",
          startDate: "01/08/2022",
          endDate: "01/08/2022",
          status: "Late",
          urgency: "Urgent",
          action: ["edit", "delete"],
          actionIcon: "@/assets/icons/vertical-dots.png",
        },
        {
          id: 3,
          todoName: "System K Design",
          issuedBy: "Erickson Maxwell",
          startDate: "01/08/2022",
          endDate: "01/08/2022",
          status: "Completed",
          urgency: "Trivial",
          action: ["edit", "delete"],
          actionIcon: "@/assets/icons/vertical-dots.png",
        },
        {
          id: 4,
          todoName: "System Y Design",
          issuedBy: "Erickson Maxwell",
          startDate: "01/08/2022",
          endDate: "01/08/2022",
          status: "Completed",
          urgency: "Mild",
          action: ["edit", "delete"],
          actionIcon: "@/assets/icons/vertical-dots.png",
        },
      ],

      urgencies: ["All", "Mild", "Urgent", "Trivial"],
    };
  },

  methods: {
    formatStatus(text) {
      text = text.toLowerCase();
      if (text === "completed") {
        return true;
      } else if (text === "late") {
        return true;
      } else if (text === "ongoing") {
        return true;
      }
    },
    handleDelete() {

    },
  },
  computed: {
    filtertodos() {
      if (
        this.searchQuery.toLowerCase() === "" ||
        this.searchQuery.toLowerCase() === "all"
      ) {
        return this.todos;
      } else {
        return this.todos.filter(
          (task) =>
            task.urgency.toLowerCase() === this.searchQuery.toLowerCase()
        );
      }
    },
    filterByTodoName() {
      if (this.todoName) {
        return this.todos.filter((task) =>
          this.todoName
            .toLowerCase()
            .split(" ")
            .every((letter) => task.todoName.toLowerCase().includes(letter))
        );
      } else {
        return this.todos;
      }
    },
    todosToShow() {
      return new Set(this.filterByTodoName.concat(this.filtertodos));
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect {
  background-color: yellow !important;
}
</style>
